import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AccountsResponse } from "./accounts.interface";

@Injectable({
  providedIn: "root",
})
export class AccountsService {
  constructor(private httpClient: HttpClient) {}

  public getAllAvailable(): Observable<AccountsResponse> {
    return this.httpClient.get<AccountsResponse>("/accounts");
  }
}
